import { jsxs, jsx } from 'react/jsx-runtime';
import Breadcrumbs from './breadcrumbs.js';
import { Menu } from '../../menubar/ui/index.js';

const Content = ({
  showLanguages = true,
  showMyAccount = true,
  showNotifications = true,
  showBreadcrumbs = true,
  customOptionsUser = [],
  currentProduct
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center", children: [
    /* @__PURE__ */ jsx(Menu, { currentProduct, showLanguages, showNotifications, showMyAccount, customOptionsUser }),
    showBreadcrumbs ? /* @__PURE__ */ jsx(Breadcrumbs, { currentProduct }) : null
  ] });
};

export { Content };
